var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigma2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 46,
    viewBox: "0 0 40 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5016 43.1136C17.0889 43.1136 20.0004 40.1101 20.0004 36.4094V29.7051H13.5016C9.91435 29.7051 7.00293 32.7086 7.00293 36.4094C7.00293 40.1101 9.91435 43.1136 13.5016 43.1136Z",
    fill: "#0ACF83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00293 22.9992C7.00293 19.2984 9.91435 16.2949 13.5016 16.2949H20.0004V29.7036H13.5016C9.91435 29.7036 7.00293 26.7 7.00293 22.9992Z",
    fill: "#A259FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00293 9.59102C7.00293 5.89024 9.91435 2.88672 13.5016 2.88672H20.0004V16.2954H13.5016C9.91435 16.2954 7.00293 13.2918 7.00293 9.59102Z",
    fill: "#F24E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.88672H26.4987C30.086 2.88672 32.9974 5.89024 32.9974 9.59102C32.9974 13.2918 30.086 16.2954 26.4987 16.2954H20V2.88672Z",
    fill: "#FF7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9974 22.9992C32.9974 26.7 30.086 29.7036 26.4987 29.7036C22.9114 29.7036 20 26.7 20 22.9992C20 19.2984 22.9114 16.2949 26.4987 16.2949C30.086 16.2949 32.9974 19.2984 32.9974 22.9992Z",
    fill: "#1ABCFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma2);
export default __webpack_public_path__ + "static/media/figma-2.53a6dcfcab9e9bdb2177ed1e91e3de27.svg";
export { ForwardRef as ReactComponent };